import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import type { FieldElement } from "@/react/types/Element";
import { Form } from "@circle-react-uikit/Form";
import { useFieldElementRules } from "../../hooks/useFieldElementRules";

interface ChoiceElementProps {
  element: FieldElement;
  errors: Record<number, string>;
  fieldIndex: number;
}

export const ChoiceElement = ({
  element,
  fieldIndex,
  errors,
}: ChoiceElementProps) => {
  const { setError } = useFormContext();
  const idName = `elements[${fieldIndex}][id]`;
  const valueName = `elements[${fieldIndex}][value]`;
  const rules = useFieldElementRules(element);

  useEffect(() => {
    if (errors && errors[fieldIndex]) {
      setError(`elements[${fieldIndex}][value]`, {
        type: "server",
        message: errors[fieldIndex],
      });
    }
  }, [errors, fieldIndex, setError]);

  const options = (element.attributes.options || []).map(option => ({
    label: option,
    value: option,
  }));

  const isMultiple = element.attributes.field_type === "multiple_choice";

  return (
    <>
      <Form.Item
        label={element.attributes.label}
        name={valueName}
        rules={rules}
        hideDescription
        hideBorder
        forceRequiredLabel={element.attributes.required}
        labelClassName="!mb-4 [overflow-wrap:anywhere]"
      >
        {isMultiple ? (
          <Form.CheckboxGroup
            name={valueName}
            options={options}
            itemLabelClassName="[overflow-wrap:anywhere]"
          />
        ) : (
          <Form.RadioGroup
            name={valueName}
            variant="radio"
            options={options}
            itemLabelClassName="[overflow-wrap:anywhere]"
          />
        )}
      </Form.Item>
      <Form.Input
        wrapperClassName="hidden"
        type="hidden"
        name={idName}
        value={element.id}
      />
    </>
  );
};
